var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsDateString, IsIn, IsInt, IsOptional, IsString, IsUrl, MaxLength } from 'class-validator';
import { HighlightTypeValues } from './highlight-type';
/**
 * Affected endpoints
 * POST /manfredite/highlights/<id>
 * PUT /manfredite/highlights/<id>
 */
export class HighlightUpdateRequest {
}
__decorate([
    Expose(),
    IsIn(HighlightTypeValues),
    __metadata("design:type", String)
], HighlightUpdateRequest.prototype, "type", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], HighlightUpdateRequest.prototype, "title", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], HighlightUpdateRequest.prototype, "category", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], HighlightUpdateRequest.prototype, "description", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", Date)
], HighlightUpdateRequest.prototype, "date", void 0);
__decorate([
    Expose(),
    IsInt({ each: true }),
    __metadata("design:type", Array)
], HighlightUpdateRequest.prototype, "technologies", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsInt(),
    __metadata("design:type", Number)
], HighlightUpdateRequest.prototype, "logoId", void 0);
__decorate([
    Expose(),
    IsUrl({ require_protocol: true }),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], HighlightUpdateRequest.prototype, "url", void 0);
//# sourceMappingURL=highlight-update.request.js.map